import React from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  CardActions,
  CardContent,
} from "@mui/material";
import profileData from "../../profileData";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import "../../App.css";
import "./Project.css";
import Slideshow from "../templates/Slideshow";
import { motion } from "framer-motion";

const Projects = () => {
  const containerVariant = {
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.5,
      },
    },
    hidden: {
      opacity: 0,
    },
  };

  const charVariant = {
    visible: {
      opacity: 1,
    },
    hidden: {
      opacity: 0,
    },
  };
  return (
    <Box className="margin-top" id="Projects">
      <Typography
        variant="h2"
        color="text.secondary"
        className="text-align-center padding-top"
        id="project_heading"
      >
        <motion.span
          variants={containerVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {"Projects".split("").map((item, index) => {
            return (
              <motion.span variants={charVariant} key={index}>
                {item}
              </motion.span>
            );
          })}
        </motion.span>
      </Typography>
      <Grid container spacing={2} className="grid-item" id="project_contents">
        {profileData.Projects.map((item, index) => {
          return (
            <Grid
              item
              key={`project_item_${index}`}
              id={`project_item_${index}`}
              component={motion.div}
              maxWidth={400}
              minHeight={650}
              className="grid-container"
              sx={{ flexDirection: "column" }}
              initial={{ translateY: -50, opacity: 0 }}
              whileInView={{ translateY: [-50,30,0], opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
            >
              <Slideshow image={item.image} title={item.title} />
              <Box className="project-content">
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    id={`project_item_${index}_title`}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    gutterBottom
                    variant="body2"
                    component="div"
                    id={`project_item_${index}_description`}
                  >
                    {item.description}
                  </Typography>
                  <Stack
                    direction="row"
                    spacing={1}
                    flexWrap="wrap"
                    useFlexGap
                    id={`project_item_${index}_techstack`}
                  >
                    {item.techStack.map((tech, index) => (
                      <Chip
                        key={`techStack_${index}`}
                        variant="outlined"
                        label={tech}
                      />
                    ))}
                  </Stack>
                </CardContent>
                <CardActions id={`project_buttons`}>
                  <Button size="small" id={`project_item_${index}_livepreview`}>
                    Live Preview
                  </Button>
                  <Button size="small" id={`project_item_${index}_github`}>
                    GitHub
                  </Button>
                </CardActions>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Projects;
